import type { ChatTheme } from '../types/theme';

const KEY_MAP: Record<keyof ChatTheme, string> = {
  primary: '--bia-primary',
  primaryText: '--bia-primary-text',
  background: '--bia-background',
  surface: '--bia-surface',
  text: '--bia-text',
  textMuted: '--bia-text-muted',
  border: '--bia-border',
  userBubble: '--bia-user-bubble',
  aiBubble: '--bia-ai-bubble',
  fontFamily: '--bia-font-family',
  borderRadius: '--bia-border-radius',
};

export function parseTheme(
  input: string | ChatTheme | null | undefined,
): Record<string, string> {
  if (input == null || input === '') return {};
  let theme: ChatTheme;
  if (typeof input === 'string') {
    try {
      theme = JSON.parse(input) as ChatTheme;
    } catch {
      return {};
    }
  } else {
    theme = input;
  }

  const out: Record<string, string> = {};
  for (const [key, cssVar] of Object.entries(KEY_MAP) as [keyof ChatTheme, string][]) {
    const value = theme[key];
    if (typeof value === 'string' && value.length > 0) {
      out[cssVar] = value;
    }
  }
  return out;
}
